'use client';

import { atom } from 'jotai';

import { reorderArray } from '../Components/FinancingCalculator/Helpers/ReorderArray';
import { calculationAtom } from './Calculation.atom';

export const eligibleProductsAtom = atom<string[] | null>(get => {
  const calculation = get(calculationAtom);

  return (
    reorderArray(calculation?.eligibleProducts ?? [], [
      'threeWayFinancing',
      'twoWayFinancing',
      'privateLeasing',
      'PCP',
    ]) ?? null
  );
});
